import 'bootstrap/dist/css/bootstrap.min.css';
import Routing from "./components/routing/Routing";


function App() {
  return (
    <div>
      <Routing></Routing>
   </div>
  );
}

export default App;
